module.exports = __webpack_public_path__ + "img/theme.efe30f1f.jpg";